import { render, staticRenderFns } from "./desktop.vue?vue&type=template&id=2d8b4b2f&"
import script from "./desktop.vue?vue&type=script&lang=ts&"
export * from "./desktop.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports